<template>
  <div>
    <div class="btn control-button control-button-red" @click="scrollup">
      <div class="button-inside-wrap">
        <img src="/static/svg/up-arrow.svg" alt="" width="50px">
      </div>
    </div>
    <div class="btn control-button control-button-red" @click="scrolldown">
      <div class="button-inside-wrap">
        <img src="/static/svg/up-arrow.svg" alt="" width="50px" style="transform: rotate(180deg);">
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'UpDownPanel',
  methods: {
    scrollup() {
      const element = document.getElementsByClassName('drug-search-list')[0];
      if (element.scrollTop >= 0) {
        element.scrollTop -= 100;
      } else {
        element.scrollTop = 0;
      }
    },
    scrolldown() {
      const element = document.getElementsByClassName('drug-search-list')[0];
      if (element.scrollTop <= element.scrollHeight) {
        element.scrollTop += 100;
      } else {
        element.scrollTop = element.scrollHeight;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// UpDownPanel.vue?ea2d7d18